module.exports = __webpack_public_path__ + "static/img/003.5c63bdb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/ustd/003.png
// module id = 0IJG
// module chunks = 1